import React, { useEffect, useState, useRef } from 'react';
import swal from 'sweetalert2';
import ImageCropper from '../components/global/imageCropper';
import * as helper from '../components/global/helper';

const imgUrl = 'https://metromatrix.s3.ap-south-1.amazonaws.com/Public/MetroMatrix/Content/';

import { getDoctorList, postDoctor } from './api/doctorAPI';
import { uploadPublicFile } from './api/fileAPI';
import EmptyView from './global/emptyView';

const Doctor = (props) => {

    const [doctors,             setDoctors]             = useState([]);
    const [filteredDoctors,     setFilteredDoctors]     = useState([]);

    const [doctor,              setDoctor]              = useState({ID: 0, Active: 'Y'});
    const [showPassword,        setShowPassword]        = useState(false);
    const [validated,           setValidated]           = useState(false);

    const [selectedImage,       setSelectedImage]       = useState(null);
    const [selectedImageType,   setSelectedImageType]   = useState(null);
    const [croppedImage,        setCroppedImage]        = useState(null);   
    const imageInputRef         = useRef(null);

    const [croppedStamp,        setCroppedStamp]        = useState(null);   
    const stampInputRef         = useRef(null);

    const [croppedSignature,    setCroppedSignature]    = useState(null);   
    const signatureInputRef     = useRef(null);

    useEffect(() => {
        fetchDoctors();
        const modalElement = document.getElementById('addModal');
        const handleModalHide = () => resetData();
        modalElement.addEventListener('hidden.bs.modal', handleModalHide);
        return () => {
            modalElement.removeEventListener('hidden.bs.modal', handleModalHide);
        };
    }, [])

    const fetchDoctors = async() => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { Doctors } = await getDoctorList();
            setDoctors(Doctors);
            setFilteredDoctors(Doctors);
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const postDoctorData = async(e)=> {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {     
            e.stopPropagation();
            setValidated(true);
        }else{
            try {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });

                let photo = doctor.Photo ? doctor.Photo : '';
                if(croppedImage){
                    const res = await uploadPublicFile(croppedImage, 'Content');
                    photo = res.FileName;
                }

                let stamp = doctor.Stamp ? doctor.Stamp : '';
                if(croppedStamp){
                    const res = await uploadPublicFile(croppedStamp, 'Content');
                    stamp = res.FileName;
                }

                if (stamp == '') {
                    swal.close();
                    swal.fire({
                        icon              : "error",
                        titleText         : "Error!",
                        text              : "Upload Stamp",
                        didOpen: () => {
                            swal.hideLoading();
                        }
                      })
                      return; 
                }

                let signature = doctor.Signature ? doctor.Signature : '';
                if(croppedSignature){
                    const res = await uploadPublicFile(croppedSignature, 'Content');
                    signature = res.FileName;
                }

                if (signature == '') {
                    swal.close();
                    swal.fire({
                        icon              : "error",
                        titleText         : "Error!",
                        text              : "Upload Signature",
                        didOpen: () => {
                            swal.hideLoading();
                        }
                      })
                      return; 
                }

                await postDoctor(
                    {
                        ...doctor,
                        Photo: photo,
                        Stamp: stamp,
                        Signature: signature
                    }
                );
                await fetchDoctors();
                document.querySelector('#addModal .btn-close').click();

                swal.close();

                if (doctor.ID) {
                    swal.fire({
                        icon: 'success',
                        title: '<small>Doctor updated successfully!</small>',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }else {
                    swal.fire({
                        icon: 'success',
                        title: '<small>Doctor added successfully!</small>',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
          
            } catch (err) {
                swal.close();
                swal.fire({
                    icon              : "error",
                    titleText         : "Error!",
                    text              : err.message
                  })
                return;  
            }
        }    
    }

    const onDoctorSearch = (searchTerm) => {
        if(!searchTerm || searchTerm === '') return setFilteredDoctors(doctors);

        //filter as per searched
        const filtered = doctors.filter(m => {
            let matchString = `${m.Name} ${m?.Email} ${m.Contact}`;
            let matchFound  = 0;
            var searchArr   = searchTerm.split(' ');
            
            searchArr.forEach(t => matchFound += matchString.toLowerCase().includes(t.toLowerCase()) ? 1 : 0);

            return matchFound === searchArr.length;
        });
        
        setFilteredDoctors(filtered);
    };

    const handleData = (key, value)=>{
        setDoctor((d)=> { return {...d, [key] : value} });
    };

    const resetData = () => {
        setDoctor({ID: 0, Active: 'Y'});
        setShowPassword(false);
        setCroppedImage(null);
        setCroppedStamp(null);
        setCroppedSignature(null);
        setValidated(false);
        imageInputRef.current.value = null;
        stampInputRef.current.value = null;
        signatureInputRef.current.value = null;
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            setSelectedImage(reader.result);
            setSelectedImageType(type);
          };
          reader.readAsDataURL(file);
        }
    };

    const handleCropComplete = (croppedImg, type) => {
        if (type == 'Stamp') {
            setCroppedStamp(croppedImg);
            stampInputRef.current.value = null; 
        }else if (type == 'Signature') {
            setCroppedSignature(croppedImg);
            signatureInputRef.current.value = null; 
        }else {
            setCroppedImage(croppedImg);
            imageInputRef.current.value = null; 
        }
        setSelectedImage(null);
        setSelectedImageType(null)
    };

    const handleCropCancel = () => {
        setSelectedImage(null);
        setSelectedImageType(null)
    };

    return ( 
        <>

            <div className="navbar navbar-expand-lg fixed-top margin-t58" style={{backgroundColor: '#fff', zIndex: '1'}}>
                <div className="container d-block padding-t10" style={{height: '60px'}}>
                    <div className='row mb-4'>
                        <div className='col-12'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'><i className="bi bi-search"></i></span>
                                <input 
                                    className="form-control fs-16" 
                                    type="search" 
                                    placeholder="Search"
                                    onChange={({target}) => onDoctorSearch(target.value)}
                                />
                            </div>
                        </div>      
                    </div>
                </div>
            </div>

            <div className='container margin-t150'>  
                <div className='row'>
                    {filteredDoctors.length > 0 ? filteredDoctors.map((m, i) => (
                        <div className='col-md-6 col-xl-4 mb-4' key={m.ID}>  
                            <div className="card mb-4 h-100 d-flex flex-column" data-bs-toggle="modal" data-bs-target="#addModal" onClick={() => setDoctor(m)}>
                                <div className="card-body d-flex flex-column justify-content-center align-items-center flex-grow-1">
                                    <div className='flex-shrink-0'>
                                        {m.Photo && m.Photo != '' ?
                                            <img src={`${imgUrl}${m.Photo}`} alt="image" className="rounded-circle" width="70" height="70"/> :
                                            <div className="initial-circle-tpa me-2">
                                                {m.Name[0]}
                                            </div>
                                        }                                           
                                    </div>
                                    <div className="mt-2 flex-grow-1 text-center">
                                        <h6 className="card-title mb-1">Dr. {m.Name}</h6>
                                        <span className='card-text fs-16'>
                                            <span><i className="bi bi-journal-check text-primary"></i> {m.Degree}</span><br/>
                                            <span><i className="bi bi-telephone text-primary"></i> {m.Contact}</span><br/>
                                            <span><i className="bi bi-envelope text-primary"></i> {m.Email}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )) : (
                        <EmptyView message={'No Doctors!'}/>
                    )}
                </div>
            </div>

            <div id='addModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">{(!doctor.ID || doctor.ID == 0) ? 'Add' : 'Update'} Doctor</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form id='doctorForm' className={`row mt-3 needs-validation ${validated ? "was-validated" : ""}`} noValidate onSubmit={postDoctorData}>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Name', helper.camelCase(target.value))}
                                                value={ doctor.Name || '' }
                                                id="txtName" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='Name' 
                                                required
                                            />
                                            <label htmlFor="txtName">Name</label>
                                            <div className="invalid-feedback">Please enter name</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Degree', target.value)}
                                                value={ doctor.Degree || '' }
                                                id="txtDegree" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='Degree' 
                                                required
                                            />
                                            <label htmlFor="txtDegree">Degree</label>
                                            <div className="invalid-feedback">Please enter degree</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input
                                                onChange={({ target }) => handleData('Email', helper.email(target.value))}
                                                value={ doctor.Email || '' }
                                                id="txtEmail" 
                                                type="email" 
                                                className="form-control" 
                                                placeholder='Email'
                                                required 
                                            />
                                            <label htmlFor="txtEmail">Email</label>
                                            <div className="invalid-feedback">Please enter email</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Contact', helper.contact(target.value))}
                                                value={ doctor.Contact || '' }
                                                id="txtContactNo" 
                                                type="text"
                                                className="form-control" 
                                                placeholder='Contact No' 
                                                required
                                            />
                                            <label htmlFor="txtContactNo">Contact No</label>
                                            <div className="invalid-feedback">Please enter contact no.</div>
                                        </div>
                                    </div>

                                    <div className='col-12 mb-3'>
                                        <div className="form-floating">
                                            <input
                                                onChange={({ target }) => handleData('Password', target.value)}
                                                value={ doctor.Password || '' }
                                                id="txtPassword" 
                                                type={showPassword ? 'text' : 'password'}
                                                className="form-control" 
                                                placeholder='Password' 
                                                required
                                            />
                                            <label htmlFor="txtPassword">Password</label>
                                            <div className="invalid-feedback">Please enter password</div>
                                            <span
                                                className='password-toggle'
                                                onClick={togglePasswordVisibility}>
                                                {showPassword ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                                            </span>
                                        </div>
                                    </div>  
                                    <div className='col-12 mb-3'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <input 
                                                ref={imageInputRef}
                                                className="form-control d-none" 
                                                type="file" 
                                                id="filePhoto"
                                                accept=".png, .jpeg, .jpg"
                                                onChange={(e) => handleFileChange(e, 'Photo')}
                                            />
                                            <label htmlFor="filePhoto" className="form-control d-flex justify-content-between align-items-center file-uploader">
                                                <span>{(!!croppedImage || doctor.Photo)  ? "Change Photo" : "Upload Photo"}</span>
                                                <span className="upload-icon" style={{ marginLeft: 'auto' }}>
                                                    <i className="bi bi-upload"></i>
                                                </span>
                                            </label>
                                            {(!!croppedImage || doctor.Photo) && (
                                                <>
                                                    <a type="button" href={croppedImage ? URL.createObjectURL(croppedImage) : `${imgUrl}${doctor.Photo}`} target='_blank' className="btn btn-primary ms-2">View</a>
                                                    <button type="button" onClick={() => {setCroppedImage(null); handleData('Photo', '')}} className="btn btn-secondary ms-2">Remove</button>
                                                </>
                                            )}
                                        </div>
                                    </div> 
                                    <div className='col-12 mb-3'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <input 
                                                ref={stampInputRef}
                                                className="form-control d-none" 
                                                type="file" 
                                                id="fileStamp"
                                                accept=".png, .jpeg, .jpg"
                                                onChange={(e) => handleFileChange(e, 'Stamp')}
                                            />
                                            <label htmlFor="fileStamp" className="form-control d-flex justify-content-between align-items-center file-uploader">
                                                <span>{(!!croppedStamp || doctor.Stamp)  ? "Change Stamp" : "Upload Stamp"}</span>
                                                <span className="upload-icon" style={{ marginLeft: 'auto' }}>
                                                    <i className="bi bi-upload"></i>
                                                </span>
                                            </label>
                                            {(!!croppedStamp || doctor.Stamp) && (
                                                <>
                                                    <a type="button" href={croppedStamp ? URL.createObjectURL(croppedStamp) : `${imgUrl}${doctor.Stamp}`} target='_blank' className="btn btn-primary ms-2">View</a>
                                                    <button type="button" onClick={() => {setCroppedStamp(null); handleData('Stamp', '')}} className="btn btn-secondary ms-2">Remove</button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className='col-12 mb-3'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <input 
                                                ref={signatureInputRef}
                                                className="form-control d-none" 
                                                type="file" 
                                                id="fileSignature"
                                                accept=".png, .jpeg, .jpg"
                                                onChange={(e) => handleFileChange(e, 'Signature')}
                                            />
                                            <label htmlFor="fileSignature" className="form-control d-flex justify-content-between align-items-center file-uploader">
                                                <span>{(!!croppedSignature || doctor.Signature)  ? "Change Signature" : "Upload Signature"}</span>
                                                <span className="upload-icon" style={{ marginLeft: 'auto' }}>
                                                    <i className="bi bi-upload"></i>
                                                </span>
                                            </label>
                                            {(!!croppedSignature || doctor.Signature) && (
                                                <>
                                                    <a type="button" href={croppedSignature ? URL.createObjectURL(croppedSignature) : `${imgUrl}${doctor.Signature}`} target='_blank' className="btn btn-primary ms-2">View</a>
                                                    <button type="button" onClick={() => {setCroppedSignature(null); handleData('Signature', '')}} className="btn btn-secondary ms-2">Remove</button>
                                                </>
                                            )}
                                        </div>
                                    </div>     
                                    <div className='col-md-12 mb-3'>
                                        <div className="form-check form-switch d-flex justify-content-center align-items-center">
                                            <label className="me-5 pe-2 mb-0">Active</label>
                                            <input 
                                                className="form-check-input switch me-5" 
                                                type="checkbox" 
                                                defaultChecked={doctor.Active == 'N' ? '' : 'checked'}
                                                onChange={(event) => handleData('Active', event.target.checked ? 'Y' : 'N')} 
                                            />
                                        </div>
                                    </div>
                                                                  
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="submit" form='doctorForm' className="btn btn-primary">Save</button>
                        </div>
                    </div>
                </div>
            </div>


            {selectedImage && (
                <div className="cropper-overlay">
                    <ImageCropper 
                        image={selectedImage}
                        type={selectedImageType}
                        dimension={selectedImageType == 'Signature' ? {width: 300, height: 150} : {width: 300, height: 150}}
                        onCropComplete={handleCropComplete}
                        onCropCancel={handleCropCancel}
                    />
                </div>
            )}

        </>
    )

}

export default Doctor;